import styled from "styled-components";

export const FormularioContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  
  height: 84vh;
  
  padding: 0 0.5rem;

  textarea {
    &:focus {
      outline: none;
      border-color: #1f73b7;
      box-shadow: 0 0 0 2px rgba(31, 115, 183, 0.2);
    }
  }
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
  margin-bottom: 0;
  margin-left: auto;
  
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 15px;

  & > * {
    width: 100%;
    text-align: left;
  }
`;

export const LabelDescricao = styled.label`
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
  color: #2f3941;
`;

export const TextareaCustom = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  height: 220px;
  border: 1px solid #d8dcde;
  border-radius: 4px;
  padding: 10px 12px;
  font-family: inherit;
  font-size: 14px;
  resize: none;
  color: #2f3941;

  &:focus {
    outline: none;
    border-color: #1f73b7;
  }
`;